/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Injectable, inject } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router'
import { WINDOW } from '../utils'
import { ConfigService } from '../config/config.service'

@Injectable({
  providedIn: 'root',
})
export class RegisterGuardService implements CanActivate {
  private _window = inject<Window>(WINDOW);
  private _configService = inject(ConfigService);


  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const path = route.url.map((segment) => segment.path).join('/')
    const endsWithRegister = path.endsWith('register')

    const hasRequiredOrganisationTypeParam = route.queryParamMap.has('type')
    const organisationTypeValue = route.queryParamMap.get('type')

    if (endsWithRegister && (!hasRequiredOrganisationTypeParam || organisationTypeValue !== 'organisation')) {
      this._window.location.href = this._configService.getExternalUrl('personalData')
    }

    return true
  }
}
